<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-loudspeaker`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2.8L24 33v8.716a2 2 0 01-2.264 1.982l-11-1.467A2 2 0 019 40.25V30l-3.392-.678A2 2 0 014 27.36V14.722a2 2 0 011.703-1.977L40 7.599V5a1 1 0 011-1h2zM13 30.883v7.615l7 .933V32.29l-7-1.406zM8 16.445l32-4.8V32.12l-32-6.4v-9.276z"/></svg>
</template>
<script>

export default {
  name: 'IconLoudspeaker',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
